import {
  AfterViewInit,
  Component, ElementRef,
  Injector,
  Optional, ViewChild
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, styler, APPLY_STYLES_TYPE, register } from "@wm/components-base";
import {WmsTranscludeDirective} from "../../../page/wms-transclude/wms-transclude.directive";

const DEFAULT_CLS = 'app-card-content card-body card-block';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-card-content',
  hostClass: DEFAULT_CLS,
};

@Component({
  selector: 'div[wmCardContent]',
  template: `
    <div partial-container-target #cardContentContainer  wmsTransclude>
      <ng-content></ng-content>
    </div>
  `,
  providers: [
    provideAsWidgetRef(CardContentComponent)
  ],
  exportAs: 'wmCardContent',
  standalone: true,
  imports: [CommonModule, WmsTranscludeDirective],
  styles: []
})
export class CardContentComponent extends StylableComponent implements AfterViewInit{
  static initializeProps = register('wm-card-content');

  @ViewChild('cardContentContainer') private cardContentContainerElRef: ElementRef;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
    styler(this.cardContentContainerElRef.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER);
  }
}

